//#region src/helpers/reverse-map.helper.ts
function buildReverseMap(myEnum) {
	return Object.keys(myEnum).reduce((accumulator, current) => {
		accumulator.set(myEnum[current], current);
		return accumulator;
	}, /* @__PURE__ */ new Map());
}
//#endregion
export { buildReverseMap };

//# sourceMappingURL=reverse-map.helper.mjs.map